import { PlanUpsellBannerSkeleton } from 'components/shared/banners/PlanUpsellBannerSkeleton';
import useCurrentSubscriptionHelper from 'hooks/billing/useCurrentSubscriptionHelper';
import React, { useMemo } from 'react';
import { Feature } from '../../../../../../../pb/subscription/v1/addon_pb';
import FulfilledByMonthLegacy from './components/FulfilledByMonthLegacy';
import LabelByMonth from './components/LabelByMonth';

export const MonthlyLabelSummary: React.FC<{ loading: boolean; hasSubscription: boolean }> = ({
    loading,
    hasSubscription,
}) => {
    const { isLegacy, isLoading, addons } = useCurrentSubscriptionHelper();

    const combinedLoading = useMemo(() => isLoading || loading, [isLoading, loading]);

    const hasLimitedMonthlyOrders = useMemo(() => {
        const monthlyOrderLimit = addons.find((addon) => addon.name === Feature.MONTHLY_ORDER_LIMIT);
        return !!monthlyOrderLimit && monthlyOrderLimit.value !== '-1';
    }, [addons]);

    if (combinedLoading) {
        return <PlanUpsellBannerSkeleton />;
    }

    if (hasSubscription && (isLegacy || hasLimitedMonthlyOrders)) {
        return <FulfilledByMonthLegacy loading={combinedLoading} hasSubscription={hasSubscription} />;
    }

    return <LabelByMonth loading={combinedLoading} hasSubscription={hasSubscription} />;
};
